import qs from 'qs';
import { network } from 'services/network';

export const getRelatedCards = (params) => {
    const queryString = qs.stringify(
        { cardId: params.id, isVirtual: params.isVirtual, versionId: params.versionId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getRelatedCards${queryString}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
